import * as angular from 'angular';
export class RedirectionLandingService {
    constructor ( private GiftCardsAppConstants: GiftCardsAppConstant, private RedirectionService: any,
        private $window : ng.IWindowService, private $rootScope: CommonsRootScope) {
        this.$rootScope.$on('redirectLandingGiftCards', (event: angular.IAngularEvent, data: { market: string, lang: string }) => this.redirection(data.market, data.lang));
    }

    redirection = (market: string, lang: string): void => {
        if (market !== 'ja' && market !== 'zh') {
            this.RedirectionService.externalRedirect(`${this.$window.location.origin}/${market}${this.GiftCardsAppConstants.LANDING_URL[lang]}`);
        } else {
            this.RedirectionService.externalRedirect(`${this.$window.location.origin}/${this.GiftCardsAppConstants.LANDING_URL[lang]}`);
        }
    };
}
RedirectionLandingService.$inject = ['GiftCardsAppConstants', 'RedirectionService', '$window', '$rootScope'];
try {
    const mod = angular.module('ib-gift-cards-service-module');
    mod.service(
        'RedirectionLandingService',
        RedirectionLandingService
    );
} catch (error) {
    const mod = angular.module('ib-gift-cards-service-module', []);
    mod.service(
        'RedirectionLandingService',
        RedirectionLandingService
    );
}